import React from "react"
import { useParams } from "react-router-dom"
import { FaArrowLeft, FaArrowRight } from "react-icons/fa"
import { Button, Loader, Table } from "../../../components/ui"
import { formatRupiah } from "../../../helper/formatNumber"
import { formatDateTransactionDetail } from "../../../helper/formatDate"
import { useProductDetail } from "../../../hooks/product/useProductDetail"
import { useProductSupplierHistory } from "../../../hooks/product/useProductSupplierHistory"

export default function ProductDetail() {
  const params = useParams()
  const productDetail = useProductDetail(params.productId)
  const productSupplierHistory = useProductSupplierHistory(params.productId)

  return (
    <div className="p-4 space-y-4">
      <h1>Detail Produk</h1>
      <ProductDetailInformation
        product={productDetail.data}
      />
      <ProductDetailHistory
        productHistory={productSupplierHistory.data}
        isLoading={productSupplierHistory.isLoading}
        isPreviousPageActive={productSupplierHistory.isPreviousPageActive}
        isNextPageActive={productSupplierHistory.isNextPageActive}
        onPreviousPage={productSupplierHistory.previousPage}
        onNextPage={productSupplierHistory.nextPage}
      />
    </div>
  )
}

function ProductDetailInformation({ product }) {
  return (
    <div className="p-5 border rounded-lg flex space-x-4">
      <ul className="flex-1 p-0 my-0 space-y-3" style={{ listStyle: 'none' }}>
        <li className="flex items-start">
          <span className="flex-none text-base font-semibold" style={{ width: '150px' }}>Produk:</span>
          <span className="flex-1 text-base font-normal">
            {product ? product.product_name : '-'}
          </span>
        </li>
        <li className="flex items-start">
          <span className="flex-none text-base font-semibold" style={{ width: '150px' }}>Unit Produk:</span>
          <span className="flex-1 text-base font-normal">
            {product ? product.product_unit.product_unit_name : '-'}
          </span>
        </li>
        <li className="flex items-start">
          <span className="flex-none text-base font-semibold" style={{ width: '150px' }}>Kategori:</span>
          <span className="flex-1 text-base font-normal">
            {product ? product.product_category.product_category_name : '-'}
          </span>
        </li>
        <li className="flex items-start">
          <span className="flex-none text-base font-semibold" style={{ width: '150px' }}>Nomor Rak:</span>
          <span className="flex-1 text-base font-normal">
            {product ? product.product_rack : '-'}
          </span>
        </li>
      </ul>
      <ul className="flex-1 p-0 my-0 space-y-3" style={{ listStyle: 'none' }}>
        <li className="flex items-start">
          <span className="flex-none text-base font-semibold" style={{ width: '150px' }}>HJB Produk:</span>
          <span className="flex-1 text-base font-normal">
            {product ? formatRupiah(product.product_hjb) : '-'}
          </span>
        </li>
        <li className="flex items-start">
          <span className="flex-none text-base font-semibold" style={{ width: '150px' }}>HJR Produk:</span>
          <span className="flex-1 text-base font-normal">
            {product ? formatRupiah(product.product_hjr) : '-'}
          </span>
        </li>
        <li className="flex items-start">
          <span className="flex-none text-base font-semibold" style={{ width: '150px' }}>Harga Rekanan:</span>
          <span className="flex-1 text-base font-normal">
            {product ? formatRupiah(product.product_partner_selling_price) : '-'}
          </span>
        </li>
        <li className="flex items-start">
          <span className="flex-none text-base font-semibold" style={{ width: '150px' }}>Stok Produk:</span>
          <span className="flex-1 text-base font-normal">
            {product ? product.product_total_stock : '-'}
          </span>
        </li>
      </ul>
    </div>
  )
}

function ProductDetailHistory({
  productHistory,
  isLoading = false,
  isPreviousPageActive = false,
  isNextPageActive = false,
  onPreviousPage,
  onNextPage
}) {
  return (
    <div className="p-5 border rounded-lg">
      <h4 className="mt-0 mb-4">Riwayat Harga Beli dan Jual</h4>
      <div className="mb-4">
        <Table striped>
          <thead>
            <tr>
              <th>No</th>
              <th>Supplier</th>
              <th>Batch Produk</th>
              <th>Tanggal Masuk</th>
              <th>Harga Beli</th>
              <th>Harga Jual</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={6} style={{ textAlign: "center" }}>
                  <Loader title="Sedang memuat data, mohon tunggu..." />
                </td>
              </tr>
            ) : (
              productHistory.length > 0 ? (
                productHistory.map((history, idx) => (
                  <tr key={history.history_id}>
                    <td>{idx + 1}</td>
                    <td>{history.supplier_name}</td>
                    <td>{history.batch_product}</td>
                    <td>{formatDateTransactionDetail(history.supplier_transaction_date)}</td>
                    <td>{history.supplier_price}</td>
                    <td>{history.pharmacy_selling_price}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} style={{ textAlign: "center" }}>
                    <span className="block text-2xl mb-2">🔍</span>
                    <span className="block text-base">Data tidak tersedia</span>
                  </td>
                </tr>
              )
            )}
          </tbody>
        </Table>
      </div>
      {productHistory.length > 0 ? (
        <div className="flex justify-end space-x-4">
          <Button
            variant="primary"
            disabled={!isPreviousPageActive}
            onClick={onPreviousPage}
          >
            <FaArrowLeft className="mr-2" />
            Sebelumnya
          </Button>
          <Button
            variant="primary"
            disabled={!isNextPageActive}
            onClick={onNextPage}
          >
            Selanjutnya
            <FaArrowRight className="ml-2" />
          </Button>
        </div>
      ) : null}
    </div>
  )
}
